import { takeLatest } from "redux-saga/effects";
import { ActionType } from "./types/actionType";
import {
  handleRetrieveManyShippingLocations,
  handleRetrieveManyCarriers,
  handleRetrieveManyCompanies,
  handleRetrieveCompany,
  handleUpdateCompany,
  handleCreateCompany,
  handleDeleteCompany,
  handleUpdateShippingLocation,
  handleCreateShippingLocation,
  handleDeleteShippingLocation,
  handleDeleteCarrier,
  handleCreateCarrier,
  handleUpdateCarrier,
} from './workers';

export function* watcher() {
  yield takeLatest(
    ActionType.RETRIEVE_MANY_SHIPPING_LOCATIONS,
    handleRetrieveManyShippingLocations
  );
  yield takeLatest(
    ActionType.RETRIEVE_MANY_CARRIERS,
    handleRetrieveManyCarriers
  );
  yield takeLatest(
    ActionType.RETRIEVE_MANY_COMPANIES,
    handleRetrieveManyCompanies
  );
  yield takeLatest(
    ActionType.RETRIEVE_COMPANY,
    handleRetrieveCompany
  );
  yield takeLatest(
    ActionType.UPDATE_COMPANY,
    handleUpdateCompany
  );
  yield takeLatest(
    ActionType.CREATE_COMPANY,
    handleCreateCompany
  );
  yield takeLatest(
    ActionType.CREATE_SHIPPING_LOCATION,
    handleCreateShippingLocation
  );
  yield takeLatest(
    ActionType.DELETE_COMPANY,
    handleDeleteCompany
  );
  yield takeLatest(
    ActionType.DELETE_SHIPPING_LOCATION,
    handleDeleteShippingLocation
  );
  yield takeLatest(
    ActionType.UPDATE_SHIPPING_LOCATION,
    handleUpdateShippingLocation
  );
  yield takeLatest(
    ActionType.DELETE_CARRIER,
    handleDeleteCarrier
  );
  yield takeLatest(
    ActionType.CREATE_CARRIER,
    handleCreateCarrier
  );
  yield takeLatest(
    ActionType.UPDATE_CARRIER,
    handleUpdateCarrier
  );
}
